import {put, take} from 'redux-saga/effects'

import * as addToLookActions from '../../actions/addToLook'
import * as dashboardActions from '../../actions/dashboard'
import * as modalActions from '../../actions/modal'

/**
 * A helper generator that handles the typical completion cases for the add to
 * look flow — opening the dashboard and closing any open look name modals
 */
export function* handleFlowCompletion() {
  yield take(addToLookActions.ADD_TO_LOOK_SUCCESS)
  yield put(modalActions.closeSlidingModal())
  yield put(dashboardActions.openDashboard())
  yield put(addToLookActions.addToLookIdle())
}
